<template>
  <modal-UI :visible="visible" :title="title" @close="$emit('close')">
    <p
      style="
        color: #1d1d1d;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-bottom: 16px;
      "
    >
      {{ text }}
    </p>
    <v-row no-gutters justify="space-between" style="margin-top: 16px">
      <admin-cancel-btn
        height="40px"
        width="calc(50% - 8px)"
        style="margin-right: 8px"
        @click="$emit('close')"
      >
        {{ cancel_btn_label ? cancel_btn_label : "Скасувати" }}
      </admin-cancel-btn>

      <admin-submit-button
        height="40px"
        width="calc(50% - 8px)"
        style="margin-right: 8px; background: #d32f2f !important"
        @click="$emit('confirm')"
      >
        {{ confirm_btn_label ? confirm_btn_label : "Видалити" }}
      </admin-submit-button>
    </v-row>
  </modal-UI>
</template>

<script>
import adminCancelBtn from "../Btns/adminCancelBtn.vue";
import adminSubmitButton from "../Btns/adminSubmitButton.vue";
import modalUI from "./modalUI.vue";

export default {
  name: "ConfirmModal",
  components: {
    adminCancelBtn,
    adminSubmitButton,
    modalUI,
  },
  props: {
    visible: {
      required: true,
    },
    title: {
      required: true,
    },
    text: {
        required: false,
    },
    cancel_btn_label: {
        required: false,
    },
    confirm_btn_label: {
       required: false,
    },
  },
};
</script>

<style scoped>
</style>
